import {ActionTree} from "vuex";
import PeopleSearchWidgetState from "@/apps/PeopleSearchWidget/models/people-search-widget-state";
import {PeopleService, PeopleServiceMock} from "@/apps/PeopleSearchWidget/services/people-service";

export default <ActionTree<PeopleSearchWidgetState, PeopleSearchWidgetState>>{
    async loadData({commit, getters}, [append, all]) {
        append ? commit('setInnerLoading', true) : commit('setLoading', true);
        append ? commit('setCurrentPage') : commit('resetCurrentPage');

        try {
            let httpService = process.env.NODE_ENV === "development" ? new PeopleServiceMock() : new PeopleService()
            let response = await httpService.getSearchResults(getters.azureService, getters.query(all));
            let results = response.results;
            if (append) {
                results = [...getters.results, ...response.results];
            }

            commit('setResults', results);
            commit('setTotalResults', response.count);
        } catch (error) {
            commit('setError', getters.errorText);
        } finally {
            commit('setLoading', false);
            commit('setInnerLoading', false);
        }
    },

    async clearData({commit}) {
        commit('setSearchQuery', '');
        commit('setResults', []);
        commit('setTotalResults', 0);
        commit('resetCurrentPage');
    },

    async onChange(context) {
        let memoryQuery = context.getters.searchQuery;

        if (context.getters.searchQuery && context.getters.searchQuery.length > 1) {
            if (memoryQuery === context.getters.searchQuery) {
                await context.dispatch('loadData', [false, false]);
            }
        } else {
            await context.dispatch('clearData');
        }
    },

    init(context, config) {
        try {
            context.commit('setConfig', config);
            context.commit('setAzureService');
        } catch (error) {
            context.commit('setError', context.getters.errorText);
        }
    }
}
